
import { defineComponent } from "vue";
import axios from "axios";

export default defineComponent({
  name: "Rooms",
  emits: ["update-focus"],
  data: () => ({
    observer: {} as MutationObserver,
    expanded: false,
    currentRoom: 0,
    currentImage: 0,
    primeAngle: -137,
    primeRadiusX: 37,
    primeRadiusY: 23,
    rooms: [] as { images: string[] }[]
  }),
  created: function() {
    axios
      .get("./_content/rooms.json")
      .then((response) => {
        this.rooms = response.data?.map((elem: {}) => {
          return {
            ...elem
          };
        });
      })
      .catch((error) => console.error(error));
  },
  mounted() {
    this.observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        const newValue = (m.target as HTMLElement).classList;
        this.$nextTick(() => {
          this.expanded =
            newValue.contains("expanded") || newValue.contains("focused");
        });
      }
    });

    this.observer.observe(this.$el, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["class"]
    });
  },
  beforeUnmount() {
    this.observer.disconnect();
  },
  methods: {
    updateFocus(focusValue: string, event: any, index?: number) {
      if ((this.expanded && focusValue !== "rooms") || !this.expanded) {
        this.$emit("update-focus", focusValue);
      } else if (typeof index === "number") {
        this.currentRoom = index || 0;
        this.currentImage = 0;
      }
      event.stopPropagation();
    },
    idxLeft(event: any) {
      this.currentImage = this.mod(
        this.currentImage - 1,
        this.rooms[this.currentRoom].images?.length
      );
      event.stopPropagation();
    },
    idxRight(event: any) {
      this.currentImage = this.mod(
        this.currentImage + 1,
        this.rooms[this.currentRoom].images?.length
      );
      event.stopPropagation();
    },
    mod(x: number, N: number) {
      return ((x % N) + N) % N;
    },
    offset(
      index: number
    ): {
      "z-index": number;
      transform?: string;
      width?: string;
      height?: string;
    } {
      let x = "";
      let y = "";
      if (!this.expanded) {
        x =
          Math.cos(this.primeAngle * index * (Math.PI / 180)) *
            this.primeRadiusX *
            (Math.floor((this.primeAngle * (index + 1)) / 360) + 1) +
          "%";
        y =
          Math.sin(this.primeAngle * index * (Math.PI / 180)) *
            this.primeRadiusY *
            (Math.floor((this.primeAngle * (index + 1)) / 360) + 1) +
          "%";
        return {
          "z-index": Math.floor(Math.random() * this.rooms.length),
          transform: `translate(${x}, ${y})`
        };
      } else {
        const x = "0px";
        const y = "0px";
        return {
          "z-index": Math.floor(Math.random() * this.rooms.length),
          transform: `translate(${x}, ${y})`
        };
      }
    },
    getTeasers(): string[] {
      return this.rooms.map((room) => room.images?.[0]);
    }
  }
});
